<template>
  <Modal title="积分兑换" v-model="visible">
    <Form ref="classHourForm" class="form" :label-width="100"
          :model="param" :rules="classHourRule" >
      <Row>
        <Col :span="12">
        <Form-item :label-width="100" label="赠课类型" prop="givingType">
          <Select v-model.number="param.giveType"  transfer>
            <Option :value="1">课时赠送</Option>
            <Option :value="2">物品赠送</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :span="22">
        <Form-item label="积分扣除" prop="activity">
          <Input v-model.number="param.activity"></Input>
        </Form-item>
        </Col>
        <Col :span="22" v-if="param.giveType === 1">
        <Form-item label="赠课次数" prop="lessonNum">
          <Input v-model.number="param.lessonNum"></Input>
        </Form-item>
        </Col>
        <Col :span="22" v-if="param.giveType === 2">
        <Form-item label="物品备注" prop="remark">
          <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                 placeholder="长度不要超过100个字符"
                 v-model="param.remark" ></Input>
        </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingUpdate" @click="update">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'UserActivityNumModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      uid: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        visible: this.value,
        loadingUpdate: false,
        param: {
          giveType: 1,
          activity: '',
          lessonNum: '',
          remark: '',
        },
        classHourRule: {
          lessonNum: [
            {type: 'integer', required: true, message: '请输入数量', trigger: 'blur'},
            {
              validator (rule, value, callback, source, options) {
                let errors = []
                if (value === 0) {
                  errors.push('数量不能为0')
                  callback(errors)
                  return
                }
                callback(errors)
              }
            },
            {type: 'integer', min: -100, max: 100, message: '请输入 -100 到 100 之间的整数', trigger: 'blur'}
          ],
          remark: [
            {required: true, message: '请输入原因', trigger: 'blur'},
            {type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur'}
          ],
          activity: [
            {type: 'integer', required: true, message: '请输入数量', trigger: 'blur'},
          ],
        }
      }
    },
    methods: {
      update () {
        let self = this
        self.loadingUpdate = true
        self.$refs.classHourForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingUpdate = false
            return
          }
          self.param.uid = self.uid
          self.$http.post('/activityExamine/activty', self.param).then(function (res) {
            self.loadingUpdate = false
            if (res) {
              self.visible = false
              self.$Message.success('兑换成功!')
              self.successCallback()
              return
            }
          })
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        this.param = {
          giveType: 1,
          activity: '',
          lessonNum: '',
          remark: ''
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserActivityNumModal.vue?21824745